import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { PageAlert } from "capitalrx-components";
import { ActionTypes } from "@/App/constants/actionTypes";
import apiService from "@/App/service";

import { getMemberAction, getGroupActions, planGetActions, getPlanAccountActions } from "@/App/actions";
import { listPlanBenefit } from "../planBenefits/search";

import { getGroup } from "../groups/get";
import { getPlanAccount } from "../planAccounts/get";

function* getMember(payload: string): Generator {
  return yield apiService({
    url: "/member/get",
    method: "POST",
    data: {
      id: payload,
    },
  });
}

function* getMemberWorker(action: ReturnType<typeof getMemberAction.getMember>): SagaIterator {
  const { payload } = action;
  const { showPageAlert } = PageAlert;

  const { getMemberResults } = getMemberAction;
  const { getPlan } = planGetActions;
  const { getPlanAccountResults } = getPlanAccountActions;

  try {
    const memberInformation = yield call(getMember, payload);
    const group = yield call(getGroup, memberInformation.group_id);
    const memberPlanAccount = yield call(getPlanAccount, group.plan_account_id);

    const { results } = yield call(listPlanBenefit, { coverage_strategy_id: group.coverage_strategy_id });

    results.map((data: { plan_benefit: { name: string } }) => {
      memberInformation.coverage_strategy_name = data.plan_benefit.name;
    });

    yield put(
      getMemberResults({
        details: memberInformation,
      }),
    );

    yield put(getGroupActions.getGroupResults(group));
    yield put(getPlan(memberPlanAccount.plan_id));
    yield put(getPlanAccountResults(memberPlanAccount));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* memberInformationWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.GET_MEMBER_INFORMATION, getMemberWorker);
}
